var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatarDesktopDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.666,
    cy: 16,
    r: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.666 0C7.84109 0 0.666016 7.17507 0.666016 16C0.666016 24.8249 7.84109 32 16.666 32C25.4909 32 32.666 24.8249 32.666 16C32.666 7.17507 25.4909 0 16.666 0ZM16.666 8.62383C19.4279 8.62383 21.6843 10.8804 21.6843 13.6421C21.6843 16.4038 19.4277 18.6604 16.666 18.6604C13.9043 18.6604 11.6477 16.4038 11.6477 13.6421C11.6477 10.8804 13.9043 8.62383 16.666 8.62383ZM8.58181 26.2737C9.76075 22.9395 12.9264 20.5474 16.666 20.5474C20.4056 20.5474 23.5713 22.9395 24.7502 26.2737C22.5265 28.025 19.6976 29.1026 16.666 29.1026C13.6002 29.0697 10.8056 28.025 8.58181 26.2737Z",
    fill: "#E37E55"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarDesktopDark);
export default __webpack_public_path__ + "static/media/avatar-desktop-dark.d361905873cde5836c5f2724bb474e6a.svg";
export { ForwardRef as ReactComponent };